import { render, staticRenderFns } from "./MomentCard.vue?vue&type=template&id=a6616a72&scoped=true"
import script from "./MomentCard.vue?vue&type=script&lang=ts"
export * from "./MomentCard.vue?vue&type=script&lang=ts"
import style0 from "./MomentCard.vue?vue&type=style&index=0&id=a6616a72&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6616a72",
  null
  
)

export default component.exports